const TURNSTILE_SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

let turnstileScriptPromise

function waitForTurnstile(timeoutMs = 12000) {
  if (typeof window !== 'undefined' && window.turnstile) {
    return Promise.resolve(window.turnstile)
  }

  return new Promise((resolve, reject) => {
    const startedAt = Date.now()
    const timer = setInterval(() => {
      if (typeof window !== 'undefined' && window.turnstile) {
        clearInterval(timer)
        resolve(window.turnstile)
        return
      }

      if (Date.now() - startedAt > timeoutMs) {
        clearInterval(timer)
        reject(new Error('Turnstile is not ready'))
      }
    }, 50)
  })
}

export function getTurnstileLanguage(locale) {
  const raw = locale ? String(locale) : 'auto'
  const normalized = raw.replace('_', '-').trim()

  if (!normalized || normalized.toLowerCase() === 'auto') {
    return 'auto'
  }

  const parts = normalized.split('-').filter(Boolean)
  if (parts.length === 1) {
    return parts[0].toLowerCase()
  }

  return `${parts[0].toLowerCase()}-${parts[1].toUpperCase()}`
}

export async function ensureTurnstileLoaded(loadScript, timeoutMs = 12000) {
  if (typeof window !== 'undefined' && window.turnstile) {
    return window.turnstile
  }

  if (!turnstileScriptPromise) {
    const existingScript = typeof document !== 'undefined'
      ? document.querySelector(`script[src^="${TURNSTILE_SCRIPT_SRC}"]`)
      : null

    if (!existingScript && typeof loadScript !== 'function') {
      throw new Error('Turnstile loader is not available')
    }

    turnstileScriptPromise = (existingScript ? Promise.resolve() : loadScript(TURNSTILE_SCRIPT_SRC))
      .then(() => waitForTurnstile(timeoutMs))
      .catch(error => {
        turnstileScriptPromise = undefined
        throw error
      })
  }

  await turnstileScriptPromise
  return window.turnstile
}
